export default "__VITE_ASSET__DZKa9_1q__"